import { useSortable } from '@dnd-kit/sortable';
import Container from '@ui/container/container';
import { ICONS } from '@ui/icons/types';
import Switch from '@ui/switch/switch';
import classNames from 'classnames';
import { CSS } from '@dnd-kit/utilities';
import Text from '@ui/text/text/text';
import styles from './profile-columns-select.module.css';
import Icon from '@ui/icons/icon';

type ProfileColumnsSortableRowProps = {
  id: string;
  label: string;
  isRemovable: boolean;
  enabled: boolean;
  onToggle: (columnId: string, enabled: boolean) => void;
};

const ProfileColumnsSortableRow = ({ id, label, isRemovable, enabled, onToggle }: ProfileColumnsSortableRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Container ref={setNodeRef} style={style} className={classNames('flex fd-row', styles.row)}>
      <Container className="flex ai-center jc-center" width="24px">
        <Container
          className={classNames(styles.dragHandle, 'ai-center jc-center')}
          {...attributes}
          {...listeners}
          aria-label="Drag to reorder"
        >
          <Icon name={ICONS.DRAG_HANDLE} size={12} color="var(--global-opacity-white-40)" />
        </Container>
      </Container>
      <Container
        className="flex flex-row ai-center jc-space-between padding-v-10 padding-h-12 radius-10"
        background="var(--global-cont-1)"
        hoverBackground="var(--global-cont-2)"
        width="100%"
      >
        <Text className="S2 flex">{label}</Text>
        <Switch value={id} on={enabled} onClick={isRemovable ? onToggle : () => {}} disabled={!isRemovable} />
      </Container>
    </Container>
  );
};

export default ProfileColumnsSortableRow;
